import debug from "debug";
import { GAServices } from "../../services/ga-services";

const log = debug("collapsible");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class Collapsible {
	constructor(element, options) {
		this.element = element;
		this.$el = $(this.element);
		this.options = options;

		const scopes = {
			document: document,
			element: this.element,
		};

		//	Look for the content element within this element or elsewhere
		const contentSelectorIsId =
			this.options.contentSelector &&
			this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[
				this.options.contentSelectorScope
			]
				? scopes[this.options.contentSelectorScope]
				: scopes["element"];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector
			? this.element.querySelector(this.options.buttonSelector)
			: this.element;

		if(!this.button) {
			log(`The provided button selector: "${this.options.buttonSelector}" failed to match a button. Aborting.`);
			return false;
		}

		log(this.element,this.options);

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content =
			this.options.contentSelector &&
			this.contentSelectorScope.querySelector(
				this.options.contentSelector
			);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";

		// Class could be multiple space separated classes
		this.collapsedClass =
			this.options.collapsedClass &&
			this.options.collapsedClass.split(" ");

		this.toggleMethod =
			this.collapseWith === "class"
				? this.toggleWithClass
				: this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		this.bindDocumentEvents = this.options.closeWithDocumentClick
			? this.bindDocumentClick
			: function () {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick
			? this.unbindDocumentClick
			: function () {};
		this.init();
		this.watch();
	}

	init() {
		// component enabled - show the button
		this.button.hidden = false;

		// Determine initial collapse state
		//	if set open option determines init state
		var doCollapse =
			this.options.open !== undefined ? !this.options.open : true;
		this.initial = true;
		this.toggleMethod(doCollapse);
		this.isCollapsed = doCollapse;
		this.setItemListName();
	}

	watch() {
		this.element.addEventListener('openCollapsible', this.open.bind(this));
		this.button.addEventListener("click", this.toggle.bind(this));
		this.attributeObserver.observe(this.element, { attributes: true });

		if (this.content) {
			this.content.addEventListener("escape", this.toggle.bind(this));
		}

		if (this.options.closeOnPageshow === true) {
			window.addEventListener('pageshow', this.handlePageShow.bind(this));
		}
	}

	toggleWithHidden(doCollapse) {
		this.button.setAttribute("aria-expanded", !doCollapse);

		if (!this.content) {
			return false;
		}
		this.content.hidden = doCollapse;
	}

	toggleWithClass(doCollapse) {
		this.button.setAttribute("aria-expanded", !doCollapse);
		if (!this.content) {
			return false;
		}
		if (doCollapse) {
			this.collapsedClass.forEach((className) => {
				this.content.classList.add(className);
			});
		} else {
			this.collapsedClass.forEach((className) => {
				this.content.classList.remove(className);
			});
		}
	}

	setItemListName() {
		const $tabBlock = this.$el.closest('.tab-recommendation-block');
		const pageType = $('body').data('pageTypeName');
		if ($tabBlock.length) {
			$(this.content).find('[ga-tracking-item]').each((index, el) => {
				const itemListName = pageType + ' - ' + this.$el.text().trim();
				el.closest('[ga-tracking-item]').setAttribute('ga-item-list-name', itemListName);
			});
		}
	}

	trackingProductSlider() {
		const $tabBlock = this.$el.closest('.has-tab');
		if ($tabBlock.length) {
			const $activeTab = $tabBlock.find('.recommendations-slider-content:not(.--is-closed)');
			GAServices.viewItemTracking($activeTab, true);
		}
	}

	// button click handler
	toggle() {
		if (!this.options.selfClosing && !this.isCollapsed) {
			return false;
		}

		const handler = this.isCollapsed
			? this.open.bind(this)
			: this.close.bind(this);
		handler();
	}

	open() {
		this.toggleMethod(false);
		this.isCollapsed = false;
		this.element.dataset.collapsibleOpen = true;
		this.bindDocumentEvents();

		const openedEvent = new CustomEvent(this.options.onUncollapse, {
			bubbles: true,
			cancelable: true,
			// detail: {}
		});

		this.element.dispatchEvent(openedEvent);
	}

	close() {
		this.toggleMethod(true);
		this.isCollapsed = true;
		this.element.dataset.collapsibleOpen = false;
		this.unbindDocumentEvents();

		const closedEvent = new CustomEvent(this.options.onCollapse, {
			bubbles: true,
			cancelable: true,
		});

		this.element.dispatchEvent(closedEvent);
	}

	bindDocumentClick() {
		document.addEventListener("click", this.onDocumentClick.bind(this));
	}

	unbindDocumentClick() {
		document.removeEventListener("click", this.onDocumentClick);
	}

	handlePageShow(event){
		if (event.persisted && this.isCollapsed === false) {
			this.close();
		}
	}

	onDocumentClick(event) {
		const clickTarget = event.target;

		// clicked this.button
		if (clickTarget === this.button || this.button.contains(clickTarget)) {
			log("clicked button");
			return false;
		}

		// clicked this.content
		if (
			this.content &&
			(clickTarget === this.content || this.content.contains(clickTarget))
		) {
			log("clicked content or inside it");
			return false;
		}

		this.close();
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter((mutation) => {
				return (
					mutation.type === "attributes" &&
					mutation.attributeName.startsWith("data-collapsible-open")
				);
			})
			.forEach(this.onOpenChanged.bind(this));
	}

	onOpenChanged(mutation) {
		const doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
		if (this.isCollapsed !== doCollapse) {
			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
			this.trackingProductSlider();
		}
	}
}

Collapsible.DEFAULTS = {
	selfClosing: true,
	onCollapse: "collapsibleClosed",
	onUncollapse: "collapsibleOpened",
};

export default Collapsible;



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__collapsible/collapsible.js